// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"d2e41df6","89":"1481f790","372":"4a944abd","718":"cb0ab76a"}[chunkId] + ".chunk.js";
};